import apiClient from '@/lib/apiClient';
import { buildListParams } from '@/shared/utils/queryUtils';
import type { PaginatedData } from '@/shared/types';

const BASE = '/admin/admins';

export type AdminRole = 'SUPER_ADMIN' | 'ADMIN' | 'MODERATOR' | 'SUPPORT';

export interface AdminUser {
  id: number;
  email: string;
  firstName?: string;
  lastName?: string;
  role: AdminRole;
  isActive?: boolean;
  lastLogin?: string | null;
  createdAt?: string;
}

export interface CreateAdminUserInput {
  email: string;
  password: string;
  firstName: string;
  lastName: string;
  role: AdminRole;
}

export const adminUserApi = {
  list: async (params: any) => {
    const res = await apiClient.get(BASE, { params: buildListParams(params) });
    return toPaginatedData<AdminUser>(res.data, params);
  },
  create: async (data: CreateAdminUserInput) => {
    const res = await apiClient.post(BASE, data);
    return res.data?.data ?? res.data;
  },
  delete: async (id: number) => {
    const res = await apiClient.post(`${BASE}/${id}/disable`);
    return res.data;
  },
};

function toPaginatedData<T>(payload: any, params: any): PaginatedData<T> {
  const data = payload?.data ?? payload;
  if (data?.content) {
    return {
      content: data.content,
      currentPage: data.currentPage ?? params?.page ?? 0,
      totalItems: data.totalItems ?? data.content.length,
      totalPages: data.totalPages ?? 1,
      pageSize: data.pageSize ?? params?.size ?? 20,
    };
  }

  const all = Array.isArray(data) ? data : [];
  const page = Number(params?.page ?? 0);
  const pageSize = Number(params?.size ?? 20);
  const start = page * pageSize;
  return {
    content: all.slice(start, start + pageSize),
    currentPage: page,
    totalItems: all.length,
    totalPages: Math.max(1, Math.ceil(all.length / pageSize)),
    pageSize,
  };
}
